import { faCartShopping, faTrashCan, faPencil, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { notifications } from "@mantine/notifications";
import _, { map, set } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { createB2BAPI } from "../../../api/Interceptor";
import "./Cart.css";
import CartProductSelect from "./CartProductSelect";
import CartVariant from "./CartVariant";
import ComboCartVariant from "./ComboCartVariant";
import EditCart from "./EditCart";
import ProceedCart from "./ProceedCart";
import RemoveCart from "./RemoveCart";
import { IconZeppelin } from "@tabler/icons-react";
import ReviewOrder from "../Shipping/ReviewOrder";
import { Badge, Input, Loader, Modal, Tabs } from "@mantine/core";
import { statesData } from "../json/StatesData";
import notify from "../../../utils/Notification";
import B2BButton from "../../common/B2BButton";
import { BASE_URL } from "../../../api/EndPoints";
import { useMediaQuery } from "@mantine/hooks";

const Cart = ({ reloadHeader }) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tabParam = params.get("tab");
  const [activeIndex, setActiveIndex] = useState(
    tabParam === "WHOLESALE"
      ? "wholesale"
      : tabParam === "SAMPLE"
        ? "sample"
        : tabParam === "SWATCH"
          ? "swatch"
          : tabParam === "SWATCHBANKORDER"
            ? "swatchbankorder"
            : "wholesale"
  );
  const [cartIndex, setCartIndex] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [isToggled, setIsToggled] = useState(false);
  const [pricesaleb, setPricesaleb] = useState([]);
  const comboCart = activeIndex === "combo";
  const sampleCart = activeIndex === "sample";
  const isMobile = useMediaQuery("(max-width: 767px)");
  const wholesaleCart = activeIndex === "wholesale";
  const swatchCart = activeIndex === "swatch";
  const swatchBankOrderCart = activeIndex === "swatchbankorder";
  const [swatchBankOrders, setSwatchBankOrders] = useState([]);
  console.log(swatchBankOrders, "mkmkmk")
  const [editSBOOpen, setEditSBOOpen] = useState(false);
  const [editingSBO, setEditingSBO] = useState(null);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [editOpenModal, setEditOpenModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [sampleSelected, setSampleSelected] = useState([]);
  const [wholesaleSelected, setWholesaleSelected] = useState([]);
  const [swatchSelected, setSwatchSelected] = useState([]); const [newVariantsAlert, setNewVariantsAlert] = useState([]);
  const [newVariantsAlertOpen, setNewVariantsAlertOpen] = useState(false);
  const [cartHistory, setCartHistory] = useState([])
  const [comboSelected, setComboSelected] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [cartsTypeItemCount, setCartsTypeItemCount] = useState(0);
  const [cartsTypeItemCounts, setCartsTypeItemCounts] = useState(0);
  const [profile, setProfile] = useState({});
  const [loyalty, setLoyalty] = useState({});
  const [loading, setLoading] = useState(false);

  const [sample, setSample] = useState([]);
  const [wholesale, setWholesale] = useState([]);
  const [sampleMoq, setSampleMoq] = useState();
  const [wholesaleMoq, setWholesaleMoq] = useState();
  const [disableSelectAll, setDisableSelectAll] = useState(false);
  const [error, setError] = useState("");
  const [combo, setCombo] = useState([]);
  const [swatch, setSwatch] = useState([]);
  const navigate = useNavigate();
  const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
  const [credit, setCredit] = useState(0);
  const [uom, setUom] = useState({})
  const [metre, setMetre] = useState({})
  const [ribData, SetRibData] = useState([]);
  const [cartLoading, setCartLoading] = useState(true);
  useEffect(() => {
    if (location?.state) {
      const type = location?.state?.cartType;
      setActiveIndex(type?.toLowerCase());
    }
    fetchCarts();
    fetchCustomer();
    fetchCartCount();
    fetchCartCountAbandoned();
    fetchSwatchBankOrders();
  }, [cartIndex, activeIndex]);
  useEffect(() => {
    fetchCartHistory()

  }, [profile])

  useEffect(() => {
    setEditingSBO(null);
  }, [activeIndex]);

  const isSavingRef = useRef(false);

  const handleCloseAndSave = () => {
    if (isSavingRef.current) return;
    isSavingRef.current = true;

    setNewVariantsAlertOpen(false);
    saveCarthistory();
  };

  const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);
  const [cityOptions, setCityOptions] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [formAddressData, setFormAddressData] = useState({
    nickName: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    pincode: "",
    country: "",
    mobileNo: "",
    email: "",
  });


  const closeSecondModal = () => {
    setIsSecondModalOpen(false);
    setIsEditMode(false);
    setFormAddressData({
      address1: "",
      address2: "",
      city: "",
      state: "",
      pincode: "",
      country: "",
      mobileNo: "",
      email: "",
    });
  };
  const handleEditAdd = (addr) => {
    setFormAddressData(addr);
    setIsEditMode(true);
    openSecondModal();
  };
  const openSecondModal = () => setIsSecondModalOpen(true);
  const handleStateChange = (event) => {
    const selectedState = event.target.value;
    const stateData = statesData.find((state) => state.name === selectedState);
    setFormAddressData({ ...formAddressData, state: selectedState, city: "" });
    setCityOptions(stateData ? stateData.districts : []);
  };

  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setFormAddressData((prev) => ({ ...prev, city: selectedCity }));
  };

  useEffect(() => {
    const stateData = statesData.find(
      (state) => state.name === formAddressData.state
    );
    setCityOptions(stateData ? stateData.districts : []);
  }, [formAddressData.state]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormAddressData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSave = async () => {
    if (!validateAddress()) return;
    try {
      const res = await B2B_API.post(`customer/location`, {

        json: formAddressData,
      });
      fetchAllAddresses();
      closeSecondModal();
    } catch (error) {
      console.error("Error on adding address:", error);
    }
  };


  const fetchCustomer = async () => {
    const res = await B2B_API.get(`customer/swatchPoint`).json();
    setCredit(res.response);
  };

  const fetchCartCount = async () => {
    const responsee = await B2B_API.get(`cart/count`).json();
    const counts = responsee.response;
    setCartsTypeItemCount(counts);
  };
  const fetchCartCountAbandoned = async () => {
    const response = await B2B_API.get(`cart/count?abandoned=${true}`).json();
    const countsAbandoned = response.response;
    setCartsTypeItemCounts(countsAbandoned);
  }
  const [sboPagination, setSboPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [hasMoreSBO, setHasMoreSBO] = useState(true);
  const [loadingMoreSBO, setLoadingMoreSBO] = useState(false);
  const sboObserverRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loadingMoreSBO && hasMoreSBO && activeIndex === "swatchbankorder") {
          setSboPagination(prev => {
            const nextPageIndex = prev.pageIndex + 1;
            fetchSwatchBankOrders(nextPageIndex, prev.pageSize, false);
            return { ...prev, pageIndex: nextPageIndex };
          });
        }
      },
      { threshold: 1.0 }
    );
    if (sboObserverRef.current) observer.observe(sboObserverRef.current);
    return () => observer.disconnect();
  }, [loadingMoreSBO, hasMoreSBO, activeIndex]);

  const fetchSwatchBankOrders = async (page = 0, size = 10, isReset = false) => {
    try {
      setLoadingMoreSBO(true);
      const res = await B2B_API.get(`swatchBankOrder/getAll?page=${page}&pageSize=${size}`).json();
      const content = res.response?.content || [];
      if (isReset) {
        setSwatchBankOrders(content);
        setSboPagination({ pageIndex: page, pageSize: size });
      } else {
        setSwatchBankOrders(prev => {
          const newItems = content.filter(newItem => !prev.some(old => old.swatchBankOrderId === newItem.swatchBankOrderId));
          return [...prev, ...newItems];
        });
      }
      setHasMoreSBO(content.length === size);
    } catch (e) {
      console.error("Error fetching swatch bank orders:", e);
    } finally {
      setLoadingMoreSBO(false);
    }
  };
  const editPanelRef = useRef(null);

  const handleEditSBO = (order) => {
    setEditingSBO(order);
    setEditSBOOpen(true);
    isMobile && setTimeout(() => {
      editPanelRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  };
  const handleSaveSBO = async () => {
    try {
      // Recalculate order-level totals from items
      const totalRoll = (editingSBO.items || []).reduce((s, i) => s + (Number(i.roll) || 0), 0);
      const totalQty = (editingSBO.items || []).reduce((s, i) => s + (Number(i.qty) || 0), 0);

      // Persist via the correct save endpoint to update the order and its nested items
      await B2B_API.post("swatchBankOrder/save", {
        json: { ...editingSBO, roll: totalRoll, qty: totalQty }
      });

      // Optimistically update local list so UI is instant
      setSwatchBankOrders((prev) =>
        prev.map((o) =>
          o.swatchBankOrderId === editingSBO.swatchBankOrderId
            ? { ...o, roll: totalRoll, qty: totalQty, items: editingSBO.items }
            : o
        )
      );

      setEditSBOOpen(false);
      setEditingSBO(null);

      await fetchSwatchBankOrders(0, 10, true);
      notify({
        success: true,
        title: "Swatch Bank Order updated successfully",
      });
    } catch (e) {
      console.error(e);
      notify({
        error: true,
        title: "Failed to update Swatch Bank Order",
      });
    }
  };

  const handleSBOItemChange = (itemId, field, value) => {
    setEditingSBO((prev) => ({
      ...prev,
      items: prev.items.map((item) =>
        item.id === itemId ? { ...item, [field]: Number(value) || 0 } : item
      ),
    }));
  };
  const getDiscountedPrice = (sellingPrice, pimVariantId, quantity, price) => {
    const priceSlabs = price[pimVariantId];
    if (!priceSlabs || priceSlabs.length === 0) return sellingPrice;

    let matchingSlab = null;

    // Step 1: Find slab with matching min-max
    for (let slab of priceSlabs) {
      if (slab.max != null && quantity >= slab.min && quantity <= slab.max) {
        matchingSlab = slab;
        break;
      }
    }

    // Step 2: Fallback to slab with max == null and min <= quantity
    if (!matchingSlab) {
      for (let slab of priceSlabs) {
        if (slab.max == null && quantity >= slab.min) {
          matchingSlab = slab;
          break;
        }
      }
    }

    // Step 3: Apply discount if slab found
    if (matchingSlab) {
      const amountBased = (matchingSlab.price || 0) !== 0;
      const discountValue = matchingSlab.price || 0;
      const discountPercent = matchingSlab.discount || 0;

      let discountedPrice;
      if (amountBased) {
        discountedPrice = sellingPrice - discountValue;
      } else {
        discountedPrice = sellingPrice - (sellingPrice * discountPercent / 100);
      }
      return discountedPrice < 0 ? 0 : discountedPrice;
    }

    // No slab matched, return original
    return sellingPrice;
  };
  console.log("newVariantsAlert", newVariantsAlert)
  const fetchCartHistory = async () => {
    try {
      if (profile.id) {

        const res = await B2B_API.get("cartHistory/getCartHistoryByUserId?userId=" + profile?.id).json()
        const allNewVariants = [...new Set(res?.response.flatMap(item => item.removedVariantName || []))]; console.log("", allNewVariants)
        setCartHistory(res.response)
        setNewVariantsAlert(allNewVariants);
        setNewVariantsAlertOpen(allNewVariants.length > 0);
      }
    }
    catch (e) {
      console.log(e)
      notify({
        error: true,
        success: false,
        title: e?.message || 'Something went wrong'
      });
    }
  }
  const saveCarthistory = async () => {
    try {
      const allids = cartHistory.map(item => item.id);
      const res = await B2B_API.get
        ("cartHistory/changeIsNotify?id=" + allids.join(",")).json()
    } catch (e) {
      console.log(e)
      notify({
        error: true,
        success: false,
        title: e?.message || 'Something went wrong'
      });
    }
  }
  const fetchCarts = async (recalculate = false, editItem) => {
    try {
      setCartLoading(true);
      const url = `cart/getall`;
      const response = await B2B_API.get(url).json();
      console.log(response, "cart all")
      const varinatSkus = response.response.map((item) => item.pimVariantId);
      const priceResponse = await B2B_API.get(
        `pricebook/priceSlabBySkus?VariantIds=${varinatSkus}`
      ).json();
      console.log(priceResponse, "price for varinat")

      setPricesaleb(priceResponse.response);
      response.response = response.response.map((item) => {
        const originalPrice = item.sellingPrice;
        const discountedPrice = getDiscountedPrice(originalPrice, item.pimVariantId, item.quantity || 0, priceResponse?.response);

        return {
          ...item,
          originalPrice,
          sellingPrice: discountedPrice, // Update with discounted price
        };

        return item;
      });
      SetRibData(response.response || []);
      const combo = await B2B_API.get(`cart/comboCart`).json();
      console.log(combo, " from combo ")
      const Swatch = await B2B_API.get(`cart/swatchCart`).json();
      console.log(Swatch, "swatch cart")
      await featchProfile();
      const rib = response.response.map((item) => item.rib === "true")

      rib.forEach((ribItem) => {
        if (combo.response !== null) {
          combo.response.forEach((comboItem) => {
            comboItem.variants?.forEach((variant) => {
              if (variant.id === ribItem.fabPimVariantId) {
                variant.ribItem = ribItem;
              }
            });
          });
        }
        if (response?.response !== null) {
          response.response.forEach((item) => {
            if (item.pimVariantId === ribItem.fabPimVariantId) {
              item.ribItem = ribItem;
            }
          });
        }
      });

      const filteredData = _.filter(response.response, (cart) => {
        return cart.cartType === "SAMPLE";
      });
      const wholeSaleData = _.filter(response.response, (cart) => {
        return cart.cartType === "WHOLESALE" && cart.rib !== "true";
      });
      const sku = [...response.response.map((item) => item.variantSku), ...response.response.map((item) => item.ribItem?.variantSku), ...combo.response.flatMap((item) => item.variants?.map((v) => v.variantSku))];
      const uom = await B2B_API.get(
        `product/uomByProduct?sku=${sku}`
      ).json();



      const merePerRoll = {}
      const result = {};
      Object.entries(uom?.response).forEach(([id, val]) => {

        if (val.kg) {
          result[id] = "kgs";
        } else if (val.metre) {
          result[id] = "metre";
        } else if (val.yard) {
          result[id] = "yard";
        } else {
          result[id] = "kgs"
        }
      });
      Object.entries(uom?.response).forEach(([id, val]) => {

        merePerRoll[id] = val?.metreValue;

      });
      setUom(result);
      setMetre(merePerRoll)
      const swatchData = Swatch.response;
      const comboData = combo.response;
      const ribIdData = comboData.flatMap((item) => item.variants?.map((v) => v.ribItem?.id)).filter(Boolean)
      const groupedSampleList = _.groupBy(filteredData, "articleCode");
      const groupedWholeSaleList = _.groupBy(wholeSaleData, "articleCode");
      const groupedswatchDataList = _.groupBy(swatchData, "articleCode");
      const moqs = await B2B_API.get("customer/moq").json();
      const { sampleMoq, wholesaleMoq } = moqs?.response;
      setSampleMoq(sampleMoq);
      setWholesaleMoq(wholesaleMoq);
      setWholesale({
        ...groupedWholeSaleList,
        ...comboData,
      });
      setSwatch(groupedswatchDataList);
      setCombo(comboData);
      setSample(groupedSampleList);
      const filterValidItems = (items) => {
        return items.filter(
          (item) =>
            item.published === "true" &&
            !(!item.backOrder && item.outOfStock) &&
            !item?.comboVariants?.includes(item?.variantSku)
        );
      };

      const filterValidComboItems = (items) => {
        return items.filter((item) => item?.variants?.length > 0 && !item.outOfStock);
      };

      setSampleSelected(filterValidItems(filteredData));
      setWholesaleSelected(filterValidItems([...wholeSaleData, ...comboData]));
      setComboSelected(filterValidComboItems(comboData));
      setSwatchSelected(filterValidItems(swatchData));

      if (recalculate) {
        let selectedArray;
        switch (editItem.cartType) {
          case "SAMPLE":
            selectedArray = sampleSelected;
            break;
          case "wholesale":

            selectedArray = wholesaleSelected.filter(
              (item) => !item.isComboItem
            );
            break;
          case "SWATCH":
            selectedArray = swatchSelected;
            break;
          default:
            selectedArray = [];
        }

        const updatedQty = selectedArray.map((item) =>
          item.id === editItem.id ? editItem : item
        );

        if (editItem.cartType === "SAMPLE") {
          setSampleSelected(updatedQty);
        } else {
          setWholesaleSelected(updatedQty);
        }
      }
    } catch (error) {
      console.error("Error fetching FabInsta:", error);
    } finally {
      setCartLoading(false);
    }
  };
  const cartItems = sampleCart
    ? sample
    : wholesaleCart
      ? {
        ...wholesale,
        ...combo,

      }
      : swatchCart
        ? swatch
        : [];

  console.log(cartItems, "cart item from cart")
  const handleToggle = () => {
    setIsToggled((prevState) => !prevState);
  };
  const calculateTotalCount = (data) => {
    return Object.values(data).reduce((sum, variants) => {
      if (Array.isArray(variants)) {
        return sum + variants.length;
      }
      return sum;
    }, 0);
  };
  const calculateComboTotalCount = (comboData) => {
    if (!comboData) return 0;
    const allItems = Array.isArray(comboData)
      ? comboData
      : Object.values(comboData).flat();
    return allItems.length;
  };

  const calculateComboAvailableCount = (data) => {
    if (!data) return 0;
    return Object.values(data).reduce((sum, combo) => {
      if (Array.isArray(combo.variants) && combo.variants.length > 0 && (!combo.outOfStock)) {
        return sum + 1;
      } else {
        return sum;
      }
    }, 0);
  }

  const featchProfile = async () => {
    try {
      setLoading(true);
      const res = await B2B_API.get("customer/profile").json();
      if (res?.response?.loyaltyId) {
        await fetchLoyalty(res.response.loyaltyId);
      }
      setProfile(res.response);
    } catch (error) {
      console.error("Error fetching recommended items:", error);
    } finally {
      setLoading(false);
    }
  }

  const fetchLoyalty = async (loyaltyId) => {
    try {
      setLoading(true);
      const res = await B2B_API.get(`loyalty/loyaltyId?loyaltyId=${loyaltyId}`).json();
      setLoyalty(res.response);
    } catch (error) {
      console.error("Error fetching recommended items:", error);
    } finally {
      setLoading(false);
    }
  }
  const calculateTotalAvailableCount = (data) => {
    return Object.values(data).reduce((sum, variants) => {
      if (variants?.combo) {
        return Object.values(data).reduce((sum, combo) => {
          if (combo?.variants?.length > 0) {
            return sum + 1;
          } else {
            return 0;
          }
        }, 0);
      }
      const publishedVariants = variants?.filter(
        (variant) =>
          variant.published === "true" &&
          !(!variant.backOrder && variant.outOfStock) &&
          !variant?.comboVariants?.includes(variant?.variantSku)
      );
      return sum + publishedVariants.length;
    }, 0);
  };

  const AllIds = (data) => {
    if (!data) return [];

    if (Array.isArray(data)) {
      return data.map((item) => item?.id).filter(Boolean);
    }

    const flat = Object.values(data).flat();
    const norId = flat.map((item) => item?.id).filter(Boolean);
    const ribId = flat.map((item) => item?.ribItem?.id).filter(Boolean);
    return [...norId, ...ribId];

  };

  const AllCartIds = (comboData) => {
    const allWrappers = Array.isArray(comboData)
      ? comboData
      : Object.values(comboData).flat();

    const ids = allWrappers.flatMap((wrapper) => {
      const mainId = wrapper.combo?.id ?? wrapper.id;
      const ribIds = wrapper.variants?.map((variant) => variant.ribItem?.id).filter(Boolean) || [];
      return [mainId, ...ribIds].filter(Boolean);
    });

    return ids;
  };

  useEffect(() => {
    const getTotalCountAndSelectState = (cartData, selectedItems, isCombo = false) => {
      const totalCount = isCombo
        ? calculateComboAvailableCount(cartData)
        : calculateTotalAvailableCount(cartData);
      const isAllSelected = totalCount > 0 && totalCount === selectedItems.length;
      return { totalCount, isAllSelected };
    };

    let totalCount = 0;
    let isAllSelected = false;

    if (sampleCart) {
      const { totalCount: sampleTotal, isAllSelected: sampleIsAllSelected } =
        getTotalCountAndSelectState(sample, sampleSelected);
      totalCount = sampleTotal;
      isAllSelected = sampleIsAllSelected;
    } else if (wholesaleCart) {
      const {
        totalCount: wholesaleTotal,
        isAllSelected: wholesaleIsAllSelected,
      } = getTotalCountAndSelectState(wholesale, wholesaleSelected);
      const { totalCount: comboTotal, isAllSelected: comboIsAllSelected } =
        getTotalCountAndSelectState(combo, comboSelected, true);

      totalCount = wholesaleTotal + comboTotal;
      isAllSelected = wholesaleIsAllSelected || comboIsAllSelected;
    } else if (comboCart) {
      const { totalCount: comboTotal, isAllSelected: comboIsAllSelected } =
        getTotalCountAndSelectState(combo, comboSelected, true);
      totalCount = comboTotal;
      isAllSelected = comboIsAllSelected;
    } else if (swatchCart) {
      const { totalCount: swatchTotal, isAllSelected: swatchIsAllSelected } =
        getTotalCountAndSelectState(swatch, swatchSelected);
      totalCount = swatchTotal;
      isAllSelected = swatchIsAllSelected;
    } else {
      setSelectAll(false);
      return;
    }
    setSelectAll(isAllSelected);
    setDisableSelectAll(totalCount === 0);
  }, [
    sample,
    wholesale,
    combo,
    swatch,
    sampleSelected,
    wholesaleSelected,
    comboSelected,
    swatchSelected,
    activeIndex,
  ]);

  const handleSelectAllChange = (e) => {
    const checked = e.target.checked;

    const filterValidComboItems = (items) => {
      const arr = Array.isArray(items) ? items : Object.values(items).flat();
      return arr.filter(
        (item) => Array.isArray(item.variants) && item.variants.length > 0 && !(item.outOfStock)
      );
    };
    const filterValidItems = (items) => {
      const arr = Array.isArray(items) ? items : Object.values(items).flat();
      return arr.filter(
        (item) =>
          item.published === "true" && !(item.backOrder === false && item.outOfStock === true)
      );
    };

    let selectedItems = [];

    const itemsMap = {
      sample,
      wholesale,
      combo,
      swatch,
    };


    if (activeIndex === "sample") {
      const allItems = Object.values(itemsMap.sample).flat();
      selectedItems = checked ? filterValidItems(allItems) : [];
      setSampleSelected(selectedItems);
    } else if (activeIndex === "wholesale") {
      const allWholesale = Object.values(wholesale).flat();
      const allCombo = Array.isArray(combo)
        ? combo
        : Object.values(combo).flat();
      if (checked) {
        setWholesaleSelected(filterValidItems(allWholesale));
        setComboSelected(filterValidComboItems(allCombo));
      } else {
        setWholesaleSelected([]);
        setComboSelected([]);
      }
      setSelectAll(checked);
    } else if (activeIndex === "swatch") {
      const allItems = Object.values(swatch).flat();
      setSwatchSelected(checked ? filterValidItems(allItems) : []);
    } else if (activeIndex === "combo") {
      const allCombo = Array.isArray(combo) ? combo : Object.values(combo).flat();
      setComboSelected(checked ? filterValidComboItems(allCombo) : []);
    }


    setSelectAll(checked);
  };

  const updateSelection = (prevSelectedItems, ...items) => {
    const selectedIds = new Set(prevSelectedItems.map((item) => item.id));

    const updatedItems = items.reduce(
      (acc, item) => {
        if (selectedIds.has(item.id)) {
          return acc.filter((selectedItem) => selectedItem.id !== item.id);
        } else {
          return [...acc, item];
        }
      },
      [...prevSelectedItems]
    );
    return updatedItems;
  };
  const updateComboselection = (prevSelectedItems, ...items) => {
    const selectedSet = new Set(prevSelectedItems.map((item) => item.combo.id));
    const updatedItems = items.reduce(
      (acc, item) => {
        if (!selectedSet.has(item.combo.id)) {
          acc.push(item);
        } else {
          const index = acc.findIndex(
            (existingItem) => existingItem.combo.id === item.combo.id
          );
          if (index !== -1) acc.splice(index, 1);
        }
        return acc;
      },
      [...prevSelectedItems]
    );

    return updatedItems;
  };
  const handleTotalChange = (items, event) => {
    const checked = event.target.checked;
    const filterValidItems = (items) => {
      return items.filter(
        (item) =>
          item.published === "true" &&
          !(item.backOrder === false && item.outOfStock === true) &&
          !item?.comboVariants?.includes(item?.variantSku)
      );
    };
    const updateSelectedItems = (prevSelected, items) => {
      if (checked) {
        return [
          ...prevSelected,
          ...filterValidItems(items).filter(
            (item) =>
              !prevSelected.some((selectedItem) => selectedItem.id === item.id)
          ),
        ];
      } else {
        return prevSelected.filter(
          (selectedItem) => !items.some((item) => item.id === selectedItem.id)
        );
      }
    };
    switch (activeIndex) {
      case "sample":
        setSampleSelected((prev) => updateSelectedItems(prev, items));
        break;
      case "wholesale":
        setWholesaleSelected((prev) => updateSelectedItems(prev, items));
        break;
      case "swatch":
        setSwatchSelected((prev) => updateSelectedItems(prev, items));
        break;

      default:
        break;
    }
  };
  const handleComboTotalChange = (item, event) => {
    const checked = event.target.checked;
    setComboSelected((prevSelectedItems) =>
      updateComboselection(prevSelectedItems, item)
    );
  };

  const handleIndividualChange = (item) => {
    if (sampleCart) {
      return setSampleSelected((prev) => updateSelection(prev, item));
    }
    if (swatchCart) {
      return setSwatchSelected((prev) => updateSelection(prev, item));
    }
    if (wholesaleCart) {
      if (Array.isArray(item.variants)) {
        return setComboSelected((prev) => updateComboselection(prev, item));
      } else {
        return setWholesaleSelected((prev) => updateSelection(prev, item));
      }
    }
  };

  const selectedStatus = (items) => {
    if (sampleCart) {
      const ids = new Set(sampleSelected.map((v) => v.id));
      return items.every((v) => ids.has(v.id));
    }
    if (swatchCart) {
      const ids = new Set(swatchSelected.map((v) => v.id));
      return items.every((v) => ids.has(v.id));
    }
    if (wholesaleCart) {
      const isComboGroup = Array.isArray(items[0]?.variants);
      if (isComboGroup) {
        const comboId = items[0].combo.id;
        return comboSelected.some((c) => c.combo.id === comboId);
      } else {
        const ids = new Set(wholesaleSelected.map((v) => v.id));
        return items.every((v) => ids.has(v.id));
      }
    }
    return false;
  };

  const handleEdit = (item) => {
    setError("");
    setEditOpenModal(true);
    setEditItem(item);
  };
  const handleEditSave = async () => {
    switch (editItem?.cartType) {
      case "SAMPLE":
        {
          const minSampleMoq =
            pricesaleb[editItem?.pimVariantId]?.filter(
              (item) => item.orderType === "SAMPLE"
            )?.[0]?.min !== (null || undefined) ? pricesaleb[editItem?.pimVariantId]?.filter(
              (item) => item.orderType === "SAMPLE"
            )?.[0]?.min : 0 ||
            editItem?.sampleMoq ||
            sampleMoq;
          const maxWholesaleMoq =
            pricesaleb[editItem?.pimVariantId]?.filter(
              (item) => item.orderType === "SAMPLE"
            )?.[0]?.max ||
            editItem?.wholesaleMoq ||
            wholesaleMoq;

          if (
            editItem?.quantity < minSampleMoq ||
            editItem?.quantity > maxWholesaleMoq || editItem?.quantity == 0
          ) {
            setError(`Min ${minSampleMoq === 0 ? 1 : minSampleMoq} ${uom[editItem?.variantSku]} - Max ${maxWholesaleMoq} ${uom[editItem?.variantSku]} .`);
            return;
          }
          if (editItem?.quantity > editItem.totalStockQuantity && !editItem.backOrder) {
            setError(`Total Available Quantity is ${editItem.totalStockQuantity} ${uom[editItem?.variantSku]} .`);
            return;
          }
        }
        break;

      case "WHOLESALE":
        {
          const minWholesaleMoq = pricesaleb[editItem?.pimVariantId]?.filter(item => item.orderType === 'WHOLESALE')[0].min || editItem?.wholesaleMoq || wholesaleMoq;
          if (editItem.quantity < editItem?.kgPerRoll) {
            setError(`Quantity must be at least ${editItem?.kgPerRoll} ${uom[editItem?.variantSku]} .`);
            return;
          }
          if (editItem.quantity > editItem?.kgPerRoll && (editItem?.quantity % (editItem.kgPerRoll || 20)) !== 0) {
            setError(`Quantity must be muliple of ${editItem?.kgPerRoll || 0}.`);
            return;
          }
          if (editItem?.quantity > editItem.availableQuantity && !editItem.backOrder) {
            setError(`Total Available Quantity is ${editItem.availableQuantity} ${uom[editItem?.variantSku]} .`);
            return;
          }
        }
        break;
      case "COMBO":
        {
          const comboMoq = editItem?.wholesaleMoq || wholesaleMoq;
          if (editItem?.quantity < comboMoq) {
            setError(`Quantity must be at least ${comboMoq} units for combo.`);
            return;
          }
        }
        break;

      case "SWATCH":
        {
          const swatchMoq = editItem.swatchMoq || swatchMoq;
          if (editItem.quantity < swatchMoq) {
            setError(
              `Quantity must be at least ${swatchMoq} units for swatch.`
            );
            return;
          }
        }
        break;

      default:
        setError("Invalid cart type.");
        return;
    }

    try {
      await B2B_API.post("cart/save", { json: editItem });
      if (editItem?.ribItem) {
        await B2B_API.post("cart/save", { json: editItem?.ribItem });
      }
      setError("");
      setEditOpenModal(false);
      fetchCarts();
    } catch (error) {
      setError("Failed to save the cart. Please try again.");
      console.error("Error saving cart item:", error);
    }
  };

  const openRemoveModal = (item) => {
    setSelectedItem(item);
    setIsOpenModal(true);
  };
  const removeAllItems = async () => {
    try {
      let idsToDelete = [];

      if (sampleCart) {
        idsToDelete = AllIds(sample);
      } else if (wholesaleCart) {
        const wholesaleIds = AllIds(wholesale);
        const comboIds = AllCartIds(combo);
        idsToDelete = [...wholesaleIds, ...comboIds];
      } else if (swatchCart) {
        idsToDelete = AllIds(swatch);
      }


      if (idsToDelete.length) {
        await B2B_API.delete(`cart/deleteALL?ids=${idsToDelete.join(",")}`);
      }

      if (sampleCart) {
        setSampleSelected([]);
        setSample({});
      } else if (wholesaleCart) {
        setWholesaleSelected([]);
        setWholesale({});
        setComboSelected([]);
        setCombo({});
      } else if (swatchCart) {
        setSwatchSelected([]);
        setSwatch({});
      }

      await fetchCarts();
      fetchCartCount();
      fetchCartCountAbandoned();
      reloadHeader();
    } catch (error) {
      console.error("Error removing all items:", error);
    } finally {
      setIsOpenModal(false);
    }
  };

  const handleRemoveItem = (item) => {
    setSelectedItem(item);
    setIsOpenModal(true);
  };

  const confirmRemove = async () => {
    try {
      if (selectedItem.combo) {
        await B2B_API.delete(`cart/delete?id=${selectedItem.combo.id}`);
      }
      else {
        await B2B_API.delete(`cart/delete?id=${selectedItem.id}`);
      }
      if (selectedItem.combo) {

        selectedItem?.variants?.forEach((variant) => {
          if (variant.ribItem) {
            B2B_API.delete(`cart/delete?id=${variant.ribItem.id}`);
          }
        });
      }
      if (selectedItem?.ribItem) {
        await B2B_API.delete(`cart/delete?id=${selectedItem.ribItem.id}`);
      }


      if (sampleCart) {
        setSampleSelected((prev) =>
          prev.filter((i) => i.id !== selectedItem.id)
        );
      } else if (swatchCart) {
        setSwatchSelected((prev) =>
          prev.filter((i) => i.id !== selectedItem.id)
        );

      } else if (wholesaleCart) {
        if (selectedItem.combo) {
          setComboSelected((prev) =>
            prev.filter((c) => c.combo.id !== selectedItem.combo.id)
          );
        } else {
          setWholesaleSelected((prev) =>
            prev.filter((v) => v.id !== selectedItem.id)
          );
        }
      }

      await fetchCarts();
      fetchCartCount();
      fetchCartCountAbandoned();
      reloadHeader();
    } catch (error) {
      console.error("Error removing item:", error);
    } finally {
      setIsOpenModal(false);
      setSelectedItem(null);
    }
  };

  const cancelRemove = () => {
    setIsOpenModal(false);
    setEditOpenModal(false);
    setSelectedItem(null);
  };

  const promoCode = "SAVE10";

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(promoCode)
      .then(() => {
        notifications.show({
          message: "Promo code has been copied!",
          position: "top-center",
          bg: "gray",
          color: "white",
        });
      })
      .catch((err) => {
        console.error("Failed to copy promo code: ", err);
      });
  };


  const getItemCountAndTotalPrice = () => {
    let selectedItems = [];
    let priceSlab = {};

    switch (activeIndex) {
      case "sample":
        selectedItems = sampleSelected;
        break;
      case "wholesale":
        selectedItems = [...wholesaleSelected, ...comboSelected];
        break;
      case "swatch":
        selectedItems = swatchSelected;
        break;
      default:
        break;
    }




    const itemCount = selectedItems.length;


    const wholesaleSum = _.sumBy(
      wholesaleSelected,
      (item) => {
        const main = item.sellingPrice * item.quantity
        const rib = item?.ribItem ? item?.ribItem?.quantity * item?.ribItem?.sellingPrice : 0;
        return main + rib
      }
    );

    const comboSum = _.sumBy(
      comboSelected,
      ({ combo, variants }) => {
        const main = combo.sellingPrice * combo.quantity * variants.length;

        const ribTotal = _.sumBy(variants, (variant) => {
          const rib = variant.ribItem;
          if (rib && rib?.sellingPrice && rib?.quantity) {
            return rib?.sellingPrice * rib?.quantity;
          }
          return 0;
        });

        return main + ribTotal
      }
    );

    const wholesaleTotal = (wholesaleSum + comboSum).toFixed(2);
    const wholesaleCount = _.size(wholesaleSelected) + _.size(comboSelected);

    const totalPrice = selectedItems.reduce((total, item) => {
      const isCombo = !!item.combo;
      const variantId = item.pimVariantId;
      const priceEntry = priceSlab[variantId] || {};

      const discount = priceEntry?.Wholesale || 0;
      const basePrice = isCombo ? item.combo.sellingPrice : item.sellingPrice;

      const price = basePrice * (1 - discount / 100);
      const parsedPrice = isNaN(price) ? 0 : parseFloat(price);

      const quantity = isCombo
        ? (item.combo.quantity || 0) * (item.combo.comboVariants?.length || 0)
        : parseInt(item.quantity || 0, 10);

      return total + parsedPrice * quantity;
    }, 0);

    return (
      <strong style={{ fontSize: "16px" }}>
        {`${itemCount} ${itemCount <= 1 ? "product" : "products"} ∙ ₹ ${sampleCart
          ? _.sumBy(
            sampleSelected,
            (item) =>
              item.sellingPrice *
              item.quantity
          ).toFixed(2)
          : wholesaleCart
            ? wholesaleTotal
            : swatchCart
              ? _.sumBy(
                swatchSelected,
                (item) =>
                  item.sellingPrice *
                  item.quantity
              ).toFixed(2)
              : comboCart
                ? _.sumBy(
                  comboSelected,
                  (item) =>
                    item.combo.sellingPrice * item.combo.quantity * item?.variants?.length
                ).toFixed(2)
                : "0.00"
          }`}
      </strong>
    );

  };


  const getStateValue = (key) => {
    if (key === "toShippingTab") {
      switch (activeIndex) {
        case "sample":
          return sampleSelected;

        case "wholesale": {
          return [...wholesaleSelected, ...comboSelected];
        }

        case "swatch":
          return swatchSelected;

        default:
          return [];
      }
    } else if (key === "cartItem") {
      switch (activeIndex) {
        case "sample":
          return sampleSelected.length;

        case "wholesale":
          return wholesaleSelected.length + comboSelected.length;

        case "swatch":
          return swatchSelected.length;

        case "combo":
          return comboSelected.length;

        default:
          return 0;
      }
    }

    return null;
  };

  const handleProceed = async () => {
    try {
      const res = await B2B_API.get("locations/verified?picked=true").json();
      if (res?.response?.length > 0) {
        navigate("/shipping", {
          state: {
            cartItem: getStateValue("toShippingTab"),

            priceSlab: getStateValue("price"),
            wholesaleSelected,
            uom,
            comboSelected,
            cartType:
              activeIndex === "sample"
                ? "SAMPLE"
                : activeIndex === "swatch"
                  ? "SWATCH"
                  : "WHOLESALE",
          },
        });
      } else {
        notify({
          error: true,
          success: false,
          title: "Please add a address to proceed",
        })
        setIsSecondModalOpen(true);

      }
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };
  const wholesaleCount = calculateTotalCount(wholesale) ?? 0;
  const comboCount = calculateComboTotalCount(combo) ?? 0;
  const isAllEmpty =
    calculateTotalCount(sample) === 0 &&
    calculateTotalCount(swatch) === 0 &&
    calculateTotalCount(wholesale) === 0 &&
    calculateComboTotalCount(combo) === 0 &&
    swatchBankOrders.length === 0;
  return (
    <div className="view-cart router-view-container">
      {(cartLoading || isAllEmpty) && (
        <div className="loading-container">
          <Loader color={"var(--primary)"} type="oval" />
        </div>
      )}
      {isOpenModal && (
        <RemoveCart
          removeAllItems={removeAllItems}
          cancelRemove={cancelRemove}
          selectedItem={selectedItem}
          confirmRemove={confirmRemove}
        />
      )}

      {editOpenModal && (
        <EditCart
          editItem={editItem}
          sampleMoq={sampleMoq}
          ribData={ribData}
          setEditItem={setEditItem}
          setError={setError}
          wholesaleMoq={wholesaleMoq}
          handleEditSave={handleEditSave}
          cancelRemove={cancelRemove}
          error={error}
          uom={uom}
        />
      )}
      <div className="cart-layout" style={{ display: "flex", gap: "6px" }}>
        <div
          className={`f-700 m-b-24 m-t-48 cursor-pointer-cartype ${!cartIndex ? "cart-selected" : ""
            }`}
          onClick={() => setCartIndex(false)}
          style={{ border: "1px solid #d1d5db" }}
        >
          Cart
          <Badge
            size="lg"
            circle
            style={{
              backgroundColor: 'var(--gray-900-06)',
              color: !cartIndex ? '#8BC53F' : 'var(--gray-600)',
              fontSize: "16px",
              marginLeft: "10px"

            }}
          >
            {cartsTypeItemCount}
          </Badge>
        </div>

        {/* <div
          className={`f-700 m-b-24 m-t-48 cursor-pointer-cartype ${cartIndex ? "cart-selected" : ""
            }`}
          onClick={() => setCartIndex(true)}
          style={{ padding: "0 24px" }}
        >
          Abandoned Cart
          <Badge
            size="lg"
            circle
            style={{
              backgroundColor: 'var(--gray-900-06)',
              color: cartIndex ? '#8BC53F' : 'var(--gray-600)',
              fontSize: "16px",
              marginLeft: "10px",
              borderRadius: "24px",
            }}
          >
            {cartsTypeItemCounts}
          </Badge>
        </div> */}
      </div>

      <div
        className="adaptive-layout boundary-width-992 cart-layout"
        style={{ gap: "24px" }}
        data-active-index={activeIndex}
      >
        <div className="first">
          <div className="view-cart-basket flex cart-route-view">
            <div className="flex cart-section-box">
              <div className="tabs">
                <div
                  className={`tab cart-section-title ${activeIndex === "wholesale" ? "selected" : ""
                    }`}
                  onClick={() => setActiveIndex("wholesale")}
                >
                  Wholesale
                  <span className="badge-count">
                    {wholesaleCount + comboCount}
                  </span>
                </div>
                <div
                  className={`tab cart-section-title ${activeIndex === "sample" ? "selected" : ""
                    }`}
                  onClick={() => setActiveIndex("sample")}
                >
                  Sample
                  <span className="badge-count">
                    {calculateTotalCount(sample)}
                  </span>
                </div>
                <div
                  className={`tab cart-section-title ${activeIndex === "swatch" ? "selected" : ""
                    }`}
                  onClick={() => setActiveIndex("swatch")}
                >
                  Swatch
                  <span className="badge-count">
                    {calculateTotalCount(swatch)}
                  </span>
                </div>
                <div
                  className={`tab cart-section-title ${activeIndex === "swatchbankorder" ? "selected" : ""
                    }`}
                  onClick={() => setActiveIndex("swatchbankorder")}
                >
                  SwatchBank
                  <span className="badge-count">
                    {swatchBankOrders.length}
                  </span>
                </div>
              </div>
              {!swatchBankOrderCart && (
                <div className="layout-items-header">
                  <div className="nk" style={{ display: "flex", alignItems: "center", flexDirection: "row", gap: "5px" }}>
                    <input
                      type="checkbox"
                      className="app-checkbox"
                      checked={selectAll}
                      onChange={(e) => handleSelectAllChange(e)}
                      disabled={disableSelectAll}
                    />
                    <div className="select-label">Select all</div>
                  </div>
                  {(sampleCart || wholesaleCart || comboCart) && (
                    <div className="f-12 flex-wrap">
                      {getItemCountAndTotalPrice()}
                    </div>
                  )}
                  <button
                    className="btns btn-default f-12 f-600"
                    onClick={() => openRemoveModal(null)}
                  >
                    <FontAwesomeIcon className="i far m-r-4" icon={faTrashCan} />
                    <span className="m-r-4">Remove</span>All
                  </button>
                </div>
              )}
              <Modal
                size="lg"
                styles={{ content: { "--modal-y-offset": "12dvh" } }}
                centered
                opened={isSecondModalOpen}
                onClose={closeSecondModal}
                title={
                  <div style={{ fontWeight: "600", fontSize: "20px" }}>
                    {isEditMode ? "Edit Address" : "New Address"}
                  </div>
                }
              >
                <div className="edit-body">
                  <div className="form-address">
                    <div className="form-control required field-nickname">
                      <label className="flex-row items-center m-b-4 asterisk">
                        <span className="flex-wrap">Address Nickname</span>
                      </label>
                      <div className="c-danger f-12 f-500 m-b-8">
                        Please do not use a PO Box for your delivery address.
                      </div>
                      <Input
                        name="nickName"
                        value={formAddressData.nickName}
                        error={errors.nickName}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="form-control required">
                      <label className="display-block asterisk">Country</label>
                      <Input
                        name="country"
                        value={formAddressData.country}
                        error={errors.country}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="address-hr"></div>

                    <div className="form-control required field-street-1">
                      <label className="flex-row items-center asterisk">
                        <span className="flex-wrap"> Street 1</span>
                      </label>
                      <Input
                        name="address1"
                        value={formAddressData.address1}
                        error={errors.address1}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="form-control field-street-2">
                      <label className="flex-row items-center asterisk">
                        <span className="flex-wrap"> Street 2</span>
                      </label>
                      <Input
                        name="address2"
                        value={formAddressData.address2}
                        error={errors.address2}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="sub-destination">
                      <div className="sub-destination">
                        <div className="form-control flex-fill m-b-0 required">
                          <label className="display-block asterisk">State</label>
                          <select
                            name="state"
                            value={formAddressData.state}
                            onChange={handleStateChange}
                          >
                            <option value="">Select State</option>
                            {statesData.map((state) => (
                              <option key={state.name} value={state.name}>
                                {state.name}
                              </option>
                            ))}
                          </select>
                          {errors.state && <div className="error">{errors.state}</div>}
                        </div>

                        <div className="form-control flex-fill m-b-0 required">
                          <label className="display-block asterisk">City</label>
                          <select
                            name="city"
                            value={formAddressData.city}
                            onChange={handleCityChange}
                            disabled={!cityOptions.length}
                          >
                            <option value="">Select City</option>
                            {cityOptions.map((city) => (
                              <option key={city} value={city}>
                                {city}
                              </option>
                            ))}
                          </select>
                          {errors.city && <div className="error">{errors.city}</div>}
                        </div>
                      </div>
                    </div>

                    <div className="form-control required field-postal-code">
                      <label className="flex-row items-center asterisk">
                        <span className="flex-wrap">Postal Code</span>
                      </label>
                      <Input
                        name="pincode"
                        value={formAddressData.pincode}
                        error={errors.pincode}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="address-hr"></div>

                    <div className="input-phone form-control required field-phone">
                      <label className="asterisk">Contact Phone</label>
                      <Input
                        name="mobileNo"
                        value={formAddressData.mobileNo}
                        error={errors.mobileNo}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="form-control required field-recipient-email">
                      <label className="flex-row items-center asterisk">
                        <span className="flex-wrap">Contact Email</span>
                      </label>
                      <Input
                        name="email"
                        value={formAddressData.email}
                        error={errors.email}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="bottom-buttons">
                      <button className="btns btn-default" onClick={closeSecondModal}>
                        Cancel
                      </button>
                      <button className="btns btn-primary" onClick={handleSave}>
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </Modal>

              {(sampleCart || wholesaleCart || swatchCart) && (
                <div className="cart-products">
                  {!cartLoading && (sampleCart && calculateTotalCount(sample) > 0) ||
                    (swatchCart && calculateTotalCount(swatch) > 0) ||
                    (wholesaleCart &&
                      calculateTotalCount(wholesale) +
                      calculateComboTotalCount(combo) >
                      0) ? (
                    <div className="items">
                      {_.map(cartItems, (items, articleCode) => (
                        <div
                          className="products-group-by-quality"
                          key={articleCode}
                        >
                          <CartProductSelect
                            selectedStatus={selectedStatus}
                            comboCart={comboCart}
                            items={items}
                            combo={combo}
                            handleComboTotalChange={handleComboTotalChange}
                            handleTotalChange={handleTotalChange}
                            comboSelected={comboSelected}
                            handleRemoveItem={handleRemoveItem}
                            uom={uom}
                          />
                          {
                            comboCart ? (
                              <>
                                <ComboCartVariant items={items} comboSelected={comboSelected} uom={uom} />
                              </>
                            ) : (
                              <CartVariant
                                items={items}
                                ribData={ribData}
                                handleIndividualChange={handleIndividualChange}
                                handleEdit={handleEdit}
                                handleRemoveItem={handleRemoveItem}
                                activeIndex={activeIndex}
                                sampleSelected={sampleSelected}
                                wholesaleSelected={wholesaleSelected}
                                swatchSelected={swatchSelected}
                                uom={uom}
                                metre={metre}
                              />)}
                        </div>
                      ))}
                    </div>
                  ) : !cartLoading && (
                    <div className="cart-empty">
                      <FontAwesomeIcon
                        icon={faCartShopping}
                        className="fal fa-4x m-b-16 display-block"
                      />
                      <div className="f-18 f-500">Cart is empty</div>
                      <button
                        className="btns btn-primary"
                        onClick={() =>
                          navigate("/fabrics", { state: { page: 0 } })
                        }
                      >
                        Start adding products
                      </button>
                    </div>
                  )}
                </div>
              )}

              {activeIndex === "swatchbankorder" && (
                <div className="cart-products">
                  {swatchBankOrders.length > 0 ? (
                    <div className="items">
                      {swatchBankOrders.map((order, idx) => (
                        <div className="products-group-by-quality" key={order.id || idx} style={{ padding: "16px", marginBottom: "12px", border: "1px solid #e2e8f0", borderRadius: "8px", background: "#fff" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "1px solid #edf2f7", paddingBottom: "10px", marginBottom: "12px" }}>
                            <div>
                              <strong style={{ fontSize: "15px", color: "var(--gray-900)" }}>Order ID: {order.swatchBankOrderId}</strong>
                              <div style={{ fontSize: "12px", color: "#718096", marginTop: "2px" }}>Ordered on: {new Date(order.createdDate).toLocaleDateString()}</div>
                              <div style={{ fontSize: "12px", color: "#718096", marginTop: "2px" }}>
                                By: {order.createdByName || order.lastUpdatedBy || "—"}&nbsp;|&nbsp;
                                Status: <span style={{ color: order.sboStatus === "APPROVEDSBO" ? "#38a169" : "#d69e2e", fontWeight: 600 }}>{order.sboStatus === "PENDINGSBO" ? "PENDING" : "APPROVED"}</span>
                              </div>
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "6px" }}>
                              {!isMobile && <div style={{ fontSize: "13px", color: "#4a5568" }}>
                                <strong>Total Rolls:</strong> {order.items && order.items.length > 0 ? order.items.reduce((s, i) => s + (Number(i.roll) || 0), 0) : order.roll}&nbsp;|&nbsp;<strong>Total Qty:</strong> {(() => {
                                  const tQty = order.items && order.items.length > 0 ? order.items.reduce((s, i) => s + (Number(i.qty) || 0), 0) : order.qty;
                                  const unitStr = order.items && order.items.length > 0
                                    ? [...new Set(order.items.map(i => i?.draftProduct?.otherInformation?.unitOfMeasures?.isMeter ? (tQty > 1 ? "Mtrs" : "Mtr") : i?.draftProduct?.otherInformation?.unitOfMeasures?.isYard ? (tQty > 1 ? "Yrds" : "Yrd") : (tQty > 1 ? "Kgs" : "Kg")))].join("/")
                                    : (tQty > 1 ? "Kgs" : "Kg");
                                  return `${tQty} ${unitStr}`;
                                })()}
                              </div>}
                              {isMobile && <div style={{ fontSize: "13px", color: "#4a5568", display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
                                <strong style={{ display: "flex", justifyContent: "flex-end" }} >Total Rolls : {order.items && order.items.length > 0 ? order.items.reduce((s, i) => s + (Number(i.roll) || 0), 0) : order.roll} </strong>
                                <strong style={{ display: "flex", justifyContent: "flex-end" }} >Total Qty : {(() => {
                                  const tQty = order.items && order.items.length > 0 ? order.items.reduce((s, i) => s + (Number(i.qty) || 0), 0) : order.qty;
                                  const unitStr = order.items && order.items.length > 0
                                    ? [...new Set(order.items.map(i => i?.draftProduct?.otherInformation?.unitOfMeasures?.isMeter ? (tQty > 1 ? "Mtrs" : "Mtr") : i?.draftProduct?.otherInformation?.unitOfMeasures?.isYard ? (tQty > 1 ? "Yrds" : "Yrd") : (tQty > 1 ? "Kgs" : "Kg")))].join("/")
                                    : (tQty > 1 ? "Kgs" : "Kg");
                                  return `${tQty} ${unitStr}`;
                                })()}</strong>
                              </div>}
                              <button
                                className="btn-edit"
                                style={{ background: "none", border: "none", cursor: "pointer", padding: "4px", display: "flex", alignItems: "center", gap: "4px" }}
                                onClick={() => handleEditSBO(order)}
                              >
                                <FontAwesomeIcon icon={faPencil} style={{ color: "#8BC53F", fontSize: "14px" }} />
                              </button>
                            </div>
                          </div>

                          {/* Items inside the order */}
                          {order.items && order.items.length > 0 ? (
                            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                              {order.items.map((item, itemIdx) => {
                                const dp = item.draftProduct;
                                const imageUrl = dp?.vendorImages?.find(Boolean)
                                  ? `${BASE_URL}${dp.vendorImages.find(Boolean).replace("/api", "")}`
                                  : null;
                                return (
                                  <div
                                    key={item.id || itemIdx}
                                    style={{ display: "flex", gap: "14px", alignItems: "center", padding: "10px", background: "#f9fafb", borderRadius: "6px", border: "1px solid #e2e8f0" }}
                                  >
                                    {/* Product image */}
                                    <div style={{ width: "60px", height: "60px", borderRadius: "6px", overflow: "hidden", backgroundColor: "#edf2f7", border: "1px solid #e2e8f0", flexShrink: 0 }}>
                                      {imageUrl ? (
                                        <img
                                          src={imageUrl}
                                          alt={dp?.articleName || "Product"}
                                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                          onError={(e) => { e.target.style.display = "none"; }}
                                        />
                                      ) : (
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", fontSize: "10px", color: "#a0aec0" }}>No Image</div>
                                      )}
                                    </div>

                                    {/* Product details */}
                                    <div style={{ flex: 1 }}>
                                      <div style={{ fontSize: "14px", fontWeight: "600", color: "#2d3748" }}>{dp?.articleName || "N/A"}</div>
                                      <div style={{ fontSize: "12px", color: "#4a5568", marginTop: "2px" }}>
                                        Code: {dp?.articleCode || dp?.draftProductId || "N/A"}
                                        {dp?.vendorName && <span>&nbsp;|&nbsp;Vendor: {dp.vendorName}</span>}
                                      </div>
                                      <div style={{ fontSize: "12px", color: "#4a5568", marginTop: "4px" }}>
                                        <strong>Roll:</strong> {item.roll}&nbsp;|&nbsp;<strong>Total Qty:</strong> {item.qty} {item?.draftProduct?.otherInformation?.unitOfMeasures?.isMeter ? (item.qty > 1 ? "Mtrs" : "Mtr") : item?.draftProduct?.otherInformation?.unitOfMeasures?.isYard ? (item.qty > 1 ? "Yrds" : "Yrd") : (item.qty > 1 ? "Kgs" : "Kg")}
                                      </div>
                                      {dp?.fabricContent?.value && (
                                        <div style={{ fontSize: "11px", color: "#718096", marginTop: "2px" }}>
                                          Fabric: {dp.fabricContent.value}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <div style={{ fontSize: "13px", color: "#a0aec0", textAlign: "center", padding: "12px 0" }}>No items in this order</div>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="cart-empty">
                      <FontAwesomeIcon
                        icon={faCartShopping}
                        className="fal fa-4x m-b-16 display-block"
                      />
                      <div className="f-18 f-500">No Swatch Bank Orders found</div>
                    </div>
                  )}
                  {swatchBankOrders.length > 0 && (
                    <div ref={sboObserverRef} style={{ height: "40px", display: "flex", justifyContent: "center", alignItems: "center", padding: "10px 0" }}>
                      {loadingMoreSBO && <div style={{ fontSize: "14px", color: "#718096" }}>Loading more orders...</div>}
                      {!hasMoreSBO && !loadingMoreSBO && <div style={{ fontSize: "12px", color: "#a0aec0" }}>No more orders</div>}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        {!swatchBankOrderCart ? (
          <ProceedCart
            items={cartItems}
            handleProceed={handleProceed}
            handleToggle={handleToggle}
            isToggled={isToggled}
            combo={combo}
            getStateValue={getStateValue}
            loyalty={loyalty}
            profile={profile}
            sampleCart={sampleCart}
            wholesaleCart={wholesaleCart}
            sampleSelected={sampleSelected}
            wholesaleSelected={wholesaleSelected}
            swatchCart={swatchCart}
            swatchSelected={swatchSelected}
            comboSelected={comboSelected}
            uom={uom}
          />
        ) : (
          <div ref={editPanelRef} className="ultron-box-price-summary cart-price-summary card-price-summary" style={{ flex: 2, background: "#fff", borderRadius: "8px", border: "1px solid var(--border-base)", height: "fit-content", position: "sticky", top: "20px", maxHeight: "80vh", overflowY: "auto" }}>
            <h3 style={{ fontSize: "18px", fontWeight: "700", marginBottom: "4px", color: "var(--gray-900)" }}>
              {editingSBO ? "Edit Swatch Bank Order" : "Select an Order to Edit"}
            </h3>
            {editingSBO ? (
              <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                {/* Order ID header */}
                <div style={{ borderBottom: "1px solid #edf2f7", paddingBottom: "10px" }}>
                  <div style={{ fontSize: "14px", fontWeight: "700", color: "#4a5568" }}>Order: {editingSBO.swatchBankOrderId}</div>
                  <div style={{ fontSize: "12px", color: "#718096", marginTop: "2px" }}>
                    Customer: {editingSBO.customer?.name || "—"} &nbsp;|&nbsp; Source: {editingSBO.source}
                  </div>
                </div>

                {editingSBO.items && editingSBO.items.length > 0 ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                    <div style={{ fontSize: "13px", fontWeight: "600", color: "#2d3748", marginBottom: "2px" }}>Items</div>
                    {editingSBO.items.map((item, itemIdx) => {
                      const dp = item.draftProduct;
                      const imageUrl = dp?.vendorImages?.find(Boolean)
                        ? `${BASE_URL}${dp.vendorImages.find(Boolean).replace("/api", "")}`
                        : null;
                      return (
                        <div key={item.id || itemIdx} style={{ padding: "12px", border: "1px solid #e2e8f0", borderRadius: "8px", background: "#f9fafb" }}>
                          {/* Item product header */}
                          <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "10px" }}>
                            <div style={{ width: "44px", height: "44px", borderRadius: "6px", overflow: "hidden", background: "#edf2f7", border: "1px solid #e2e8f0", flexShrink: 0 }}>
                              {imageUrl ? (
                                <img src={imageUrl} alt={dp?.articleName} style={{ width: "100%", height: "100%", objectFit: "cover" }} onError={(e) => { e.target.style.display = "none"; }} />
                              ) : (
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", fontSize: "9px", color: "#a0aec0" }}>No Img</div>
                              )}
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div style={{ fontSize: "13px", fontWeight: "600", color: "#2d3748", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{dp?.articleName || "N/A"}</div>
                              <div style={{ fontSize: "11px", color: "#718096" }}>{dp?.articleCode || dp?.draftProductId || ""}</div>
                            </div>
                          </div>

                          {/* Roll & Qty inputs */}
                          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                            <div>
                              <label style={{ display: "block", fontSize: "11px", fontWeight: "600", color: "#4a5568", marginBottom: "4px" }}>Rolls</label>
                              <input
                                type="number"
                                min="0"
                                style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #d1d5db", fontSize: "13px", boxSizing: "border-box" }}
                                value={item.roll ?? 0}
                                onChange={(e) => handleSBOItemChange(item.id, "roll", e.target.value)}
                              />
                            </div>
                            <div>
                              <label style={{ display: "block", fontSize: "11px", fontWeight: "600", color: "#4a5568", marginBottom: "4px" }}>Qty ({item?.draftProduct?.otherInformation?.unitOfMeasures?.isMeter ? (item.qty > 1 ? "Mtrs" : "Mtr") : item?.draftProduct?.otherInformation?.unitOfMeasures?.isYard ? (item.qty > 1 ? "Yrds" : "Yrd") : (item.qty > 1 ? "Kgs" : "Kg")})</label>
                              <input
                                type="number"
                                min="0"
                                style={{ width: "100%", padding: "8px", borderRadius: "6px", border: "1px solid #d1d5db", fontSize: "13px", boxSizing: "border-box" }}
                                value={item.qty ?? 0}
                                onChange={(e) => handleSBOItemChange(item.id, "qty", e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div style={{ fontSize: "13px", color: "#a0aec0", textAlign: "center", padding: "12px 0" }}>No items in this order</div>
                )}

                {/* Order-level totals (auto-computed) */}
                <div style={{ background: "#f0fff4", border: "1px solid #c6f6d5", borderRadius: "8px", padding: "10px 14px" }}>
                  <div style={{ fontSize: "12px", fontWeight: "600", color: "#276749", marginBottom: "4px" }}>Order Totals (auto-computed from items)</div>
                  <div style={{ fontSize: "13px", color: "#2d6a4f" }}>
                    <strong>Total Rolls:</strong> {(editingSBO.items || []).reduce((s, i) => s + (Number(i.roll) || 0), 0)}&nbsp;&nbsp;
                    <strong>Total Qty:</strong> {(() => {
                      const tQty = (editingSBO.items || []).reduce((s, i) => s + (Number(i.qty) || 0), 0);
                      const unitStr = (editingSBO.items && editingSBO.items.length > 0) ? [...new Set(editingSBO.items.map(i => i?.draftProduct?.otherInformation?.unitOfMeasures?.isMeter ? (tQty > 1 ? "Mtrs" : "Mtr") : i?.draftProduct?.otherInformation?.unitOfMeasures?.isYard ? (tQty > 1 ? "Yrds" : "Yrd") : (tQty > 1 ? "Kgs" : "Kg")))].join("/") : (tQty > 1 ? "Kgs" : "Kg");
                      return `${tQty} ${unitStr}`;
                    })()}
                  </div>
                </div>

                {/* Action buttons */}
                <div style={{ display: "flex", gap: "12px", marginTop: "4px" }}>
                  <button className="btns btn-default" style={{ flex: 1, padding: "12px" }} onClick={() => setEditingSBO(null)}>
                    Cancel
                  </button>
                  <button className="btns btn-primary" style={{ flex: 1, padding: "12px" }} onClick={handleSaveSBO}>
                    Save All
                  </button>
                </div>
              </div>
            ) : (
              <div style={{ color: "#718096", fontSize: "14px", textAlign: "center", padding: "24px 0" }}>
                Click the <FontAwesomeIcon icon={faPencil} style={{ color: "#8BC53F", fontSize: "14px" }} /> pencil icon next to an order to edit its items.
              </div>
            )}
          </div>
        )}
      </div>
      <Modal
        opened={newVariantsAlertOpen}
        onClose={handleCloseAndSave}
        centered
        title={
          <span style={{
            fontSize: "20px",
            fontWeight: "700",
            color: "#d32f2f"
          }}>
            Out of stock!!!
          </span>}>
        <div style={{
          fontSize: 15,
          lineHeight: "22px",
          color: "#444",
          marginBottom: "10px"
        }}>
          Some of selected Combo variants {newVariantsAlert.length > 0 && `(${newVariantsAlert})`} are out of stock.
        </div>

        <div style={{
          display: "flex",
          gap: "12px",
          justifyContent: "flex-end"
        }}>
          <B2BButton
            name="Okay"
            style={{
              backgroundColor: "#8BC53F",
              color: "white",
              padding: "8px 16px",
              borderRadius: 6,
              fontWeight: "600",
              minWidth: 100
            }}
            onClick={() => {
              setNewVariantsAlertOpen(false);
              saveCarthistory()
            }}
          />
        </div>
      </Modal>
    </div>

  );
};

export default Cart;

